<template>
    <div class="ruler">
        <div v-if="zoom > 50" :style="'width:' + zoom + 'px'" class="r1"/>
        <div v-if="zoom > 25 && zoom < 50" :style="'width:' + 5 * zoom + 'px'" class="r5"/>
        <div v-if="zoom > 10 && zoom <= 25" :style="'width:' + 10 * zoom + 'px'" class="r10"/>
        <div v-if="zoom > 5 && zoom <= 10" :style="'width:' + 25 * zoom + 'px'" class="r25"/>
        <div v-if="zoom > 2.5 && zoom <= 5 " :style="'width:' + 50 * zoom + 'px'" class="r50"/>
        <div v-if="zoom > 1 && zoom <= 2.5" :style="'width:' + 100 * zoom + 'px'" class="r100"/>
        <div v-if="zoom > 0.5 && zoom <= 1" :style="'width:' + 250 * zoom + 'px'" class="r250"/>
        <div v-if="zoom > 0.25 && zoom <= 0.5 " :style="'width:' + 500 * zoom + 'px'" class="r500"/>
        <div v-if="zoom > 0.1 && zoom <= 0.25 " :style="'width:' + 1000 * zoom + 'px'" class="r1000"/>
        <div v-if="zoom > 0.04 && zoom <= 0.1 " :style="'width:' + 2000 * zoom + 'px'" class="r2000"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'zoom',
            'center'
        ]),
    }
};
</script>

<style lang="scss">
.ruler {
    white-space: nowrap;
}

.ruler > div {
    height: 1.2em;
    color: rgb(35, 118, 153);
    font-weight: bold;
    border-bottom: 2px solid rgb(35, 118, 153);
    border-left: 2px solid rgb(35, 118, 153);
    border-right: 2px solid rgb(35, 118, 153);

    @media (max-width: 768px) {
        height: 10px;
    }
}

.ruler > div:before {
    float: right;
    margin-right: 0.5em;
    margin-top: -0.2em;

    @media (max-width: 768px) {
        margin-top: -13px;
    }
}

.r1:before {
    content: "1 mm";
}
.r5:before {
    content: "5 mm";
}
.r10:before {
    content: "1 cm";
}
.r25:before {
    content: "2.5 cm";
}
.r50:before {
    content: "5 cm";
}
.r100:before {
    content: "10 cm";
}
.r250:before {
    content: "25 cm";
}
.r500:before {
    content: "50 cm";
}
.r1000:before {
    content: "1 m";
}
.r2000:before {
    content: "2 m";
}

</style>
